import React from "react";

import { Icon } from "@culturehq/components";
import { Trans } from "app/utils";

const TrendsetterBadge = ({ justIcon }) => {
  if (justIcon) {
    return (
      <span className="Story__Trendsetter">
        <span className="Story__Trendsetter-text">
          <Icon icon="thunder-filled" />
        </span>
      </span>
    );
  }

  return (
    <span className="Story__Trendsetter">
      <span className="Story__Trendsetter-text">
        <Icon icon="thunder-filled" />
        <Trans>Trendsetter</Trans>
      </span>
    </span>
  );
};

export default TrendsetterBadge;
